// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var assetBundleFence = {
    fence_0: require("../assets/packed/fence/fence-0.json"),
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/assetBundleFence.ts
// module id = 1733
// module chunks = 3